import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'

export enum RepresentativeRoutesEnum {
    DatatableRepresentatives = '/representantes/representantes',
    ShowRepresentative = '/representantes/representantes/:id',
    StoreRepresentative = '/representantes/representantes/cadastrar',
    DatatableRepContracts = '/representantes/contratos',
    DatatablePayments = '/representantes/pagamentos',
    ShowPayment = '/representantes/pagamentos/:id',
    DatatableRepUsers = '/representantes/acessos/usuarios',
    ShowRepUser = '/representantes/acessos/usuarios/:cpf',
    StoreRepUser = '/representantes/acessos/usuarios/cadastrar',
    DatatableRepPrivileges = '/representantes/acessos/perfis',
    StoreRepPrivilege = '/representantes/acessos/perfis/cadastrar',
    UpdateRepPrivilege = '/representantes/acessos/perfis/:id',
}

export default function RepresentativeRouter() {
    /*Representantes*/
    const DatatableRepresentatives = lazy(
        () => import('../../pages/representative/representatives/DatatableRepresentative')
    )
    const ShowRepresentative = lazy(
        () => import('../../pages/representative/representatives/ShowRepresentative')
    )
    const StoreRepresentative = lazy(
        () => import('../../pages/representative/representatives/StoreRepresentative')
    )

    /*Contratos*/
    const DatatableRepContracts = lazy(
        () => import('../../pages/representative/contracts/DatatableRepContracts')
    )

    /*Pagamentos*/
    const DatatablePayments = lazy(
        () => import('../../pages/representative/payments/DatatablePayments')
    )
    const ShowPayment = lazy(() => import('../../pages/representative/payments/ShowPayment'))

    /*Usuários*/
    const DatatableRepUsers = lazy(
        () => import('../../pages/representative/access/users/DatatableRepUsers')
    )
    const ShowRepUser = lazy(() => import('../../pages/representative/access/users/ShowRepUser'))
    const StoreRepUser = lazy(() => import('../../pages/representative/access/users/StoreRepUser'))

    /*Perfis*/
    const DatatableRepPrivileges = lazy(
        () => import('../../pages/representative/access/privileges/DatatableRepPrivileges')
    )
    const StoreRepPrivilege = lazy(
        () => import('../../pages/representative/access/privileges/StoreRepPrivilege')
    )
    const UpdateRepPrivilege = lazy(
        () => import('../../pages/representative/access/privileges/UpdateRepPrivilege')
    )

    return (
        <Switch>
            {/*Representantes*/}
            <Route
                path={RepresentativeRoutesEnum.StoreRepresentative}
                component={StoreRepresentative}
            />
            <Route
                path={RepresentativeRoutesEnum.ShowRepresentative}
                component={ShowRepresentative}
            />
            <Route
                path={RepresentativeRoutesEnum.DatatableRepresentatives}
                component={DatatableRepresentatives}
            />

            {/*Contratos*/}
            <Route
                path={RepresentativeRoutesEnum.DatatableRepContracts}
                component={DatatableRepContracts}
            />

            {/*Pagamentos*/}
            <Route path={RepresentativeRoutesEnum.ShowPayment} component={ShowPayment} />
            <Route
                path={RepresentativeRoutesEnum.DatatablePayments}
                component={DatatablePayments}
            />

            {/*Usuários*/}
            <Route path={RepresentativeRoutesEnum.StoreRepUser} component={StoreRepUser} />
            <Route path={RepresentativeRoutesEnum.ShowRepUser} component={ShowRepUser} />
            <Route
                path={RepresentativeRoutesEnum.DatatableRepUsers}
                component={DatatableRepUsers}
            />

            {/*Perfis*/}
            <Route
                path={RepresentativeRoutesEnum.StoreRepPrivilege}
                component={StoreRepPrivilege}
            />
            <Route
                path={RepresentativeRoutesEnum.UpdateRepPrivilege}
                component={UpdateRepPrivilege}
            />
            <Route
                path={RepresentativeRoutesEnum.DatatableRepPrivileges}
                component={DatatableRepPrivileges}
            />
        </Switch>
    )
}
